export default "__VITE_ASSET__CItrgqMs__"